import {
  ErrorBoundary,
  Illustration,
  SearchInput,
  TableBody,
  TableHead,
  TableSkeleton,
  Text,
  HStack,
  VStack,
} from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box, Center } from 'native-base';
import React from 'react';

import { AllAdvisorsOrAllPartnersWarning } from './components/AllAdvisorsOrAllPartnersWarning';
import { ButtonRefresh } from './components/ButtonRefresh';
import { HeaderSection } from './components/HeaderSection';
import { TradingCustomerListTable } from './components/TradingCustomerListTable';
import { rowHeight } from './components/TradingCustomerListTable/constants';
import { searchPlaceholder } from './constants';
import { TradingTypes } from './types';

export const ContainerDesktop: React.FC<TradingTypes.Props> = ({
  isMobile,
  onSetSearchTerm,
  onClearSearchTerm,
  onLoadMore,
  tradingList,
  tradingListLoading,
  tradingListError,
  filtered,
  handleNavigate,
  renderedItems,
  onRefresh,
  updatedAt,
}) => {
  const loadingTable = () => {
    const Width = Math.floor(100 / 7);
    return (
      <Box>
        <TableHead testId="loading-table-head">
          {Array.from({ length: 7 }).map((_, colIndex) => (
            <TableSkeleton key={colIndex.toString()} color="neutral.white" width={Width} />
          ))}
        </TableHead>
        {Array.from({ length: 4 }).map((_, rowIndex) => (
          <TableBody key={rowIndex.toString()} testId="loading-table-body" height={rowHeight}>
            {Array.from({ length: 7 }).map((_item, colIndex) => (
              <TableSkeleton
                key={colIndex.toString()}
                color="brand.primary.lightest"
                width={Width}
              />
            ))}
          </TableBody>
        ))}
      </Box>
    );
  };

  return (
    <VStack
      maxWidth={1200}
      px={Utils.Responsive.TabletDesktop({
        tablet: Spacing['inline.xxxs'],
        desktop: Spacing['inline.xs'],
      })}
      alignSelf={'center'}
      minHeight="fit-content"
      width="100%"
      flex={1}>
      <VStack flex={1} justifyContent="flex-start">
        <HeaderSection title={'Day trade'} isMobile={isMobile} />
        <VStack
          flex={1}
          bg={{ base: 'transparent', sm: Color['neutral.white'] }}
          px={{ sm: Spacing['inline.xxs'] }}
          pt={Spacing['stack.xxs']}
          space="stack.xxxs">
          <HStack width={'100%'} justifyContent={'space-between'}>
            <SearchInput
              isLoading={tradingListLoading}
              onClear={onClearSearchTerm}
              onSearch={onSetSearchTerm}
              placeholder={searchPlaceholder}
            />

            <ButtonRefresh onRefresh={onRefresh} updatedAt={updatedAt} />
          </HStack>
          <AllAdvisorsOrAllPartnersWarning />

          {(tradingListError && filtered && (
            <VStack alignItems="center">
              <VStack alignItems="center" space={Spacing['stack.quarck']}>
                <Illustration name="NotFoundIllustration" testId={'empty-illustration'} />
                <Text
                  textAlign={'center'}
                  paddingTop={Spacing['stack.xxxs']}
                  fontSize={Utils.Responsive.All({
                    phone: Typography['fontsize.xs'],
                    tablet: Typography['fontsize.xs'],
                    desktop: Typography['fontsize.md'],
                  })}
                  variant="bold"
                  color="neutral.black">
                  Nenhum resultado corresponde à sua pesquisa.
                </Text>
                <Text
                  textAlign={'center'}
                  fontSize={Utils.Responsive.All({
                    phone: Typography['fontsize.xs'],
                    tablet: Typography['fontsize.xs'],
                    desktop: Typography['fontsize.md'],
                  })}
                  lineHeight="medium"
                  color="neutral.black">
                  Por favor, verifique o campo informado e tente novamente.
                </Text>
              </VStack>
            </VStack>
          )) ||
            (tradingListError && (
              <Center flex={1} backgroundColor={Color['neutral.white']}>
                <ErrorBoundary onRefresh={onRefresh} />
              </Center>
            ))}

          {!tradingListError && !tradingListLoading && (
            <TradingCustomerListTable
              renderedItems={renderedItems}
              handleNavigate={handleNavigate}
              tradingList={tradingList}
              onLoadMore={onLoadMore}
              filtered={filtered}
            />
          )}

          {tradingListLoading && <>{loadingTable()}</>}
        </VStack>
      </VStack>
    </VStack>
  );
};
